import React, { memo } from 'react';
import CollapsiblePanel, { type CollapsiblePanelProps } from './CollapsiblePanel';

export type CollapsibleCardProps = {
  title: string;
  subtitle?: string;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  defaultExpanded?: boolean;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  disabled?: boolean;
  loading?: boolean;
  unmountWhenCollapsed?: boolean;
  className?: string;
  children: React.ReactNode;
  /** Stable key for session persistence (maps to panel id). */
  storageKey: string;
  /** Namespace for persistence keys; defaults to `dashboard`. */
  storageScope?: string;
};

function CollapsibleCardInner({
  storageKey,
  storageScope = 'dashboard',
  unmountWhenCollapsed = true,
  ...props
}: CollapsibleCardProps) {
  const panelProps: CollapsiblePanelProps = {
    id: storageKey,
    storageScope,
    unmountWhenCollapsed,
    ...props,
  };
  return <CollapsiblePanel {...panelProps} />;
}

const CollapsibleCard = memo(CollapsibleCardInner);
CollapsibleCard.displayName = 'CollapsibleCard';

export default CollapsibleCard;
